import { createAction } from '@reduxjs/toolkit';
import {
  GET_COMMON_ACCESS,
  SET_COMMON_ACCESS,
  GET_BUILDING_CAMERAS,
  GET_NVR_AVAILABLE,
  GET_USER_FAVORITE_CAMERAS,
  ADD_USER_FAVORITE_CAMERA,
  REMOVE_USER_FAVORITE_CAMERA
} from '../constants';

export const getCommonAccess = createAction(GET_COMMON_ACCESS);
export const setCommonAccess = createAction(SET_COMMON_ACCESS);
export const getBuildingCameras = createAction(GET_BUILDING_CAMERAS);
export const getNvrAvailable = createAction(GET_NVR_AVAILABLE);

export const getUserFavoriteCameras = createAction(GET_USER_FAVORITE_CAMERAS);
export const addUserFavoriteCamera = createAction(ADD_USER_FAVORITE_CAMERA);
export const removeUserFavoriteCamera = createAction(REMOVE_USER_FAVORITE_CAMERA);

export default {
  getCommonAccess,
  setCommonAccess,
  getBuildingCameras,
  getNvrAvailable,
  getUserFavoriteCameras,
  addUserFavoriteCamera,
  removeUserFavoriteCamera
};
